import { DragOverlay } from "@dnd-kit/core";
import { ReactNode } from "react";

export function CopyOfDraggable({ children }: { children: ReactNode }) {
  return <DragOverlay>{children}</DragOverlay>;
}
